import React from "react"
import { Table, Thead, Tbody, Tfoot, Tr, Th, Td } from "@chakra-ui/react"
import {
  BeatTableProps,
  BeatTbodyProps,
  BeatTdProps,
  BeatTfootProps,
  BeatTheadProps,
  BeatThProps,
  BeatTrProps
} from "./types"

export const BeatTableContainer: React.FC<BeatTableProps> = ({ children, variant, ...props }) => {
  return (
    <Table {...props} variant={variant}>
      {children}
    </Table>
  )
}

export const BeatThead: React.FC<BeatTheadProps> = ({ children, ...props }) => <Thead {...props}>{children}</Thead>

export const BeatTbody: React.FC<BeatTbodyProps> = ({ children, ...props }) => <Tbody {...props}>{children}</Tbody>

export const BeatTr: React.FC<BeatTrProps> = ({ children, ...props }) => <Tr {...props}>{children}</Tr>

export const BeatTh: React.FC<BeatThProps> = ({ children, ...props }) => <Th {...props}>{children}</Th>

export const BeatTd: React.FC<BeatTdProps> = ({ children, ...props }) => <Td {...props}>{children}</Td>

export const BeatTfoot: React.FC<BeatTfootProps> = ({ children, ...props }) => <Tfoot {...props}>{children}</Tfoot>
